









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryBillInfoList } from '@/api'
import { DateFormat, DateFormat2 } from '@/utils/date/DateUtil'
import { PriceFormat, BillStatusFormat, OverdueTypeFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import PayDescDialog from '@/views/pay/PayDescDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    PayDescDialog,
  },
})
export default class BillList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '是否逾期', param: 'isOverdue', type: 'select', selectData: constant.OverdueType },
    { title: '账单状态', param: 'billStatus', type: 'select', selectData: constant.BillStatus },
    { title: '客户手机号', param: 'mobilePhone' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = []
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '账单编号', param: 'billCode' },
    { title: '账单周期', param: 'billPeriod', formatter: DateFormat2 },
    { title: '客户手机号', param: 'mobilePhone' },
    { title: '账单金额', param: 'billAmount', formatter: PriceFormat },
    { title: '返还积分', param: 'returnIntegral', formatter: PriceFormat },
    { title: '订单数量', param: 'orderCount' },
    { title: '是否逾期', param: 'isOverdue', formatter: OverdueTypeFormat },
    { title: '状态', param: 'billStatus', formatter: BillStatusFormat },
    { title: '支付订单', param: 'payOrderNo', overflow: true, click: this.openPay },
    { title: '创建时间', param: 'createTime', formatter: DateFormat, overflow: true },
  ]

  public async created() {
    this.loadData()
  }

  public async loadData() {
    const param = { ...this.queryParam, orderBy: 'create_time desc' }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryBillInfoList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private openPay(cellValue: any, row: any, index: number) {
    console.log('展示订单详情')
    const d = this.$refs.PayDescDialog as PayDescDialog
    d.open(cellValue)
  }
}
